import React from 'react'
import { string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Paper from 'components/atoms/Paper'
import Typography from 'components/atoms/Typography'
import Markdown from 'components/atoms/MarkdownContent'

import Relazsizes from 'relazsizes'
import config from 'config'

const { assets_url: assetsUrl } = config

const ScholarshipBenefit = ({
  title,
  tuitionFee,
  livingCost,
  description,
}) => (
  <div id="benefits" className="scholarship-benefits">
    <SectionContainer paddingTop={80} backgroundColor="#f6f7fa">
      <Container>
        <SectionTitle title={title || 'Benefit'} />
        <Row className="scholarship-benefits__boxes">
          <Col md="6">
            <Paper shadowed rounded>
              <div className="scholarship-benefits__box">
                <Relazsizes
                  dataSrc={`${assetsUrl}/assets/img/biaya-kuliah2x.png`}
                  className="scholarship-benefits__box-img"
                  alt="Biaya Kuliah - Beasiswa Quipper Campus"
                />
                <div className="scholarship-benefits__box-text">
                  <Typography variant="headline" component="h4">
                    Biaya Kuliah
                  </Typography>
                  <Typography variant="body" component="p">
                    {tuitionFee}
                  </Typography>
                </div>
              </div>
            </Paper>
          </Col>
          <Col md="6">
            <Paper shadowed rounded>
              <div className="scholarship-benefits__box">
                <Relazsizes
                  dataSrc={`${assetsUrl}/assets/img/wallet2x.png`}
                  className="scholarship-benefits__box-img"
                  alt="Biaya Hidup - Beasiswa Quipper Campus"
                />
                <div className="scholarship-benefits__box-text">
                  <Typography variant="headline" component="h4">
                    Biaya Hidup
                  </Typography>
                  <Typography variant="body" component="p">
                    {livingCost}
                  </Typography>
                </div>
              </div>
            </Paper>
          </Col>
        </Row>
        <Markdown className="scholarship-benefits__description" content={description} />
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .scholarship-benefits {
          &__box {
            padding: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            height: 100%;
            @media screen and (min-width: 768px) {
              flex-direction: row;
              text-align: left;
            }
          }
          :global(.campus-paper) {
            height: 100%;
          }
          :global(&__description) {
            padding-top: 40px;
          }
          :global(&__box-img) {
            width: 100%;
            margin: 32px;
            @media screen and (min-width: 768px) {
              width: 100px;
              margin: 16px;
            }
          }
        }
      `}
    </style>
  </div>
)

ScholarshipBenefit.propTypes = {
  title: string,
  tuitionFee: string,
  livingCost: string,
  description: string,
}

export default ScholarshipBenefit
